import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["vatTab", "lineItemsTab", "vatContent", "lineItemsContent"]
  static values = { default: { type: String, default: "vat" } }

  connect() {
    this.showTab(this.defaultValue)
  }

  showVat() { this.showTab("vat") }
  showLineItems() { this.showTab("line_items") }

  navigate(event) {
    const tabs = [this.vatTabTarget, this.lineItemsTabTarget]
    const index = tabs.indexOf(event.target)
    if (index < 0 || !["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return
    event.preventDefault()
    const next = event.key === "Home" ? 0 : event.key === "End" ? 1 : 1 - index
    this.showTab(next === 0 ? "vat" : "line_items")
    tabs[next].focus()
  }

  showTab(tab) {
    const isVat = tab === "vat"
    ;[[this.vatTabTarget, isVat], [this.lineItemsTabTarget, !isVat]].forEach(([button, selected]) => {
      button.setAttribute("aria-selected", String(selected))
      button.tabIndex = selected ? 0 : -1
    })
    this.vatContentTarget.classList.toggle("hidden", !isVat)
    this.lineItemsContentTarget.classList.toggle("hidden", isVat)
  }
}
